<template>
  <div>
    <div v-if="!isEmpty(ranks)">
      <div class="box"
        v-for="(r, key) in ranks" :key="key"
        style="margin-bottom: 10px; padding: 10px;"
      >
        <div class="columns is-fullwidth is-gapless" style="margin-bottom: 0;">
          <div class="column is-narrow" style="margin-right: 15px;">
            <span class="tag is-medium" :class="{'is-warning': key == 0, 'is-light': key == 1, 'is-bronze': key == 2}">
              #{{ parseFloat(key) + 1 }}
            </span>
          </div>

          <div class="column">
            <article class="media" style="margin-bottom: 10px;">
              <figure class="media-left">
                <div class="image is-32x32 is-circle">
                  <avatar :avatar_url="!isEmpty(r.avatar) ? r.avatar.thumb.link : null"></avatar>
                </div>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong>
                      <a class="has-text-dark"
                        @click.prevent="isTeacher ? showResult(r.quizMemberId) : ''"
                        href=""
                        style="white-space: nowrap;"
                      >{{ getName(r) }}</a>
                    </strong>
                    <br>
                    {{ !isEmpty(r.nim) ? r.nim : '-' }}
                  </p>
                </div>
              </div>
            </article>

            <div class="columns is-mobile is-vcentered is-fullwidth">
              <div class="column">
                <p class="has-text-grey font-12">Benar</p>
                <p class="font-22"><strong class="has-text-primary">{{ r.totalCorrect }}</strong></p>
              </div>
              <div class="column">
                <p class="has-text-grey font-12">Salah</p>
                <p class="font-18"><strong class="has-text-danger">{{ r.totalWrong }}</strong></p>
              </div>
              <div class="column">
                <p class="has-text-grey font-12">Nilai</p>
                <p class="font-18"><strong>{{ r.totalScore }}</strong></p>
              </div>
              <div class="column">
                <p class="has-text-grey font-12">Peluang Curang</p>
                <p class="font-18"><strong class="has-text-danger">{{ r.cheatOpportunity }}</strong></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="has-text-centered" v-if="ranks.length > 5">
        <button class="button is-text is-small" @click.prevent="show_all = !show_all">Tampilkan Semua</button>
      </div>
    </div>
    <div v-else>
      <p>Tidak ada peserta</p>
    </div>
  </div>
</template>

<script>
import modal from "~/utils/modal";
import QUIZ_MIXIN from '~/mixins/quiz';

export default {
  mixins: [QUIZ_MIXIN],

  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },

  mounted() {
    this.getRank(this.id);
  },

  data() {
    return {
      ranks: [],
      selected_quiz_member_id: null
    }
  },

  methods: {
    getName(r) {
      return !this.isEmpty(r.namaMahasiswa) ? r.namaMahasiswa : r.namaUser;
    },
    showResult(quiz_member_id) {
      this.selected_quiz_member_id = quiz_member_id;

      Vue.nextTick(() => {
        modal.show('#result-modal');
      })
    },
    onGetRankSuccess(res) {
      this.ranks = res.data.ranks
    }
  }
}
</script>

<style>

</style>
